import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { LehreFormGroup } from '../../bewerbung-einreichen/bewerbung-einreichen-form-groups';
import { DateRangeComponent } from '../../../common/date-range/date-range.component';
import { FloatLabel } from 'primeng/floatlabel';
import { InputText } from 'primeng/inputtext';
import { Select } from 'primeng/select';
import { TrimInputValueDirective } from '../../../../services/form/trim-input-value.directive';
import { Fluid } from 'primeng/fluid';
import { Fieldset } from 'primeng/fieldset';
import { Button } from 'primeng/button';

import { BRANCHEN } from '../../../../models/branchen.model';

@Component({
  selector: 'app-lehre[lehreFormGroup]',
  imports: [DateRangeComponent, FloatLabel, InputText, ReactiveFormsModule, Select, TrimInputValueDirective, Fluid, Fieldset, Button],
  templateUrl: './lehre.component.html',
  styleUrl: './lehre.component.scss'
})
export class LehreComponent {
  @Input()
  public lehreFormGroup!: FormGroup<LehreFormGroup> | null;

  @Output()
  public remove: EventEmitter<void> = new EventEmitter<void>();

  protected branches: string[] = BRANCHEN;
}
